import React from 'react'
import {Link} from "react-router-dom"
const Footer = () => {
  return (
    <div>
    <footer className="text-gray-600 body-font" style={{ userSelect: "auto" }}>
  <div
    className="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col"
    style={{ userSelect: "auto" }}
  >
    <a
      className="flex title-font font-medium items-center md:justify-start justify-center no-underline text-gray-900"
      style={{ userSelect: "auto" }}
    >
      <img className='w-10 h-10 rounded-full'  src='/home_hira.jpeg'></img>
      <span className="ml-3 text-xl " style={{ userSelect: "auto" }}>
       Dr.Hira Mujahid
      </span>
    </a>
    <p
      className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4"
      style={{ userSelect: "auto" }}
    >
      © 2022 Ph.d Hira —
      <a
        href="https://twitter.com/knyttneve"
        className="text-gray-600 ml-1 no-underline"
        rel="noopener noreferrer"
        target="_blank"
        style={{ userSelect: "auto" }}
      >
        @IoBM
    <Link to="/login" className='no-underline text-black mx-2'> Admin</Link>
      </a>


    </p>
   
    <span
      className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start"
      style={{ userSelect: "auto" }}
    >
      <a className="text-gray-500 cursor-pointer mx-2" href='https://www.youtube.com/channel/UCRGkU7BCH_caSnWLsj7Svcw' target='blank' style={{ userSelect: "auto" }}>
      <i className="fa fa-youtube" />
      </a>
   
      <a className="text-gray-500 cursor-pointer"   href="https://www.facebook.com/profile.php?id=100067835761988&is_tour_dismissed=true" target="blank" style={{ userSelect: "auto" }}>
        <svg
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5"
          viewBox="0 0 24 24"
          style={{ userSelect: "auto" }}
        >
          <path
            d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
            style={{ userSelect: "auto" }}
          />
        </svg>
      </a>
      <a className="ml-3 text-gray-500 cursor-pointer" style={{ userSelect: "auto" }}>
        <svg
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5"
          viewBox="0 0 24 24"
          style={{ userSelect: "auto" }}
        >
          <path
            d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"
            style={{ userSelect: "auto" }}
          />
        </svg>
      </a>
      <a className="ml-3 text-gray-500  cursor-pointer" style={{ userSelect: "auto" }}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5"
          viewBox="0 0 24 24"
          style={{ userSelect: "auto" }}
        >
          <rect
            width={20}
            height={20}
            x={2}
            y={2}
            rx={5}
            ry={5}
            style={{ userSelect: "auto" }}
          />
          <path
            d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"
            style={{ userSelect: "auto" }}
          />
        </svg>
      </a>
      <a className="ml-3 text-gray-500 cursor-pointer"  href="https://pk.linkedin.com/in/dr-hira-mujahid-512a164b" target="blank" style={{ userSelect: "auto" }}>
        <svg
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0}
          className="w-5 h-5"
          viewBox="0 0 24 24"
          style={{ userSelect: "auto" }}
        >
          <path
            stroke="none"
            d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
            style={{ userSelect: "auto" }}
          />
          <circle
            cx={4}
            cy={4}
            r={2}
            stroke="none"
            style={{ userSelect: "auto" }}
          />
        </svg>
      </a>
    </span>
  </div>
</footer>

    </div>
  )
}

export default Footer